const base = process.env.PUBLIC_URL

const endpoints = {
  home: '/',
  livros: '/livros',
  postagens: '/leituras',
  postagensCadastro: '/leituras/cadastro/',
  emprestimo: '/emprestimo',
  reservas: '/reservas',
  sugestao: '/sugestao',
  dashboard: '/dashboard',
  autoEmprestimo: '/autoemprestimo',
  livro: '/livro',
  403: '/forbiden',
  erroPermissoes: '/erro-permissoes'
}

let rotas = {}
Object.keys(endpoints).forEach(item => {
  rotas = { ...rotas, [item]: base + endpoints[item] }
})

export default rotas
